import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "src/store/rootStore";

interface NavigationSliceState {
  breadcrumbs: BreadcrumbItem[];
  snackbar: {
    open: boolean;
    message: string;
    type?: "success" | "error" | "warning";
  };
}

export interface BreadcrumbItem {
  label: string;
  index?: number;
  path?: string;
}

const navigationSlice = createSlice({
  name: "navigation",
  initialState: {
    breadcrumbs: [],
    snackbar: {
      open: false,
      message: "",
    },
  } as NavigationSliceState,
  reducers: {
    addBreadcrumb: (state, action: PayloadAction<BreadcrumbItem>) => {
      state.breadcrumbs.push(action.payload);
    },
    removeBreadcrumb: (state, action: PayloadAction<number>) => {
      state.breadcrumbs.splice(action.payload, state.breadcrumbs.length);
    },
    clearBreadcrumbs: (state) => {
      state.breadcrumbs = [];
    },
    showSnackbar: (
      state,
      action: PayloadAction<{
        open?: boolean;
        message: string;
        type?: "success" | "error" | "warning";
      }>,
    ) => {
      state.snackbar = {
        open: action.payload.open || false,
        message: action.payload.message,
        type: action.payload.type,
      };
    },
  },
});

export const selectBreadcrumbs = (state: RootState) =>
  state.navigation.breadcrumbs;
export const selectSnackbar = (state: RootState) => state.navigation.snackbar;

export const {
  addBreadcrumb,
  removeBreadcrumb,
  clearBreadcrumbs,
  showSnackbar,
} = navigationSlice.actions;

export default navigationSlice.reducer;
